import { Component, OnInit,Input,OnChanges,SimpleChanges  } from '@angular/core';
import { ProductService } from "../services/product/product.service";
import { CategoryService } from "../services/category/category.service";
import { CartService } from "../services/cart/cart.service";
import { UserService } from "../services/user/user.service";
import {Router} from "@angular/router"
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnChanges {
  categories
  fournisseurs
  selectedCategories = []
  selectedFournisseurs = []
  selectedProducts
  searchField = ''
  @Input() isLoged;
  @Input() isLogedB2c;

  constructor(private userService:UserService,private router:Router,private productService:ProductService,private categoryService:CategoryService,public cartService:CartService ) {

  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isLoged']) {
      
            // this.isLoged = this.isLoged;
    }
	}

  logout()
  {

    this.userService.logOut().subscribe(res=>{
      if (localStorage.getItem('user')) {
        localStorage.setItem('user',null)
      }
      if (localStorage.getItem('token')) {
        localStorage.setItem('token',null)
      }

      this.isLoged = false;
      this.router.navigate(['/'])
    },
    err =>{
      console.log(err);
    }
  )

  }

  search(){
    var req = this.searchField
    this.productService.searchByKeyWord(req, 1).subscribe(res =>{
      this.selectedProducts = res
    })
    this.categoryService.allCategories().subscribe(res =>{
      this.categories   =  res['categories']
      this.fournisseurs =  Object.entries(res['fournisseurs'])
      this.getCategorie(this.categories,req)
      this.getFournisseur(this.fournisseurs,req)

    })
  }
  getCategorie(categories, re){
    console.log("#####################",categories);
    
      this.selectedCategories = []
      re = re.toLowerCase();
      categories.forEach((el1,key1) => {
        console.log(el1);
        
        if(el1[1].titre.toLowerCase().includes(re)){
          this.selectedCategories.push({id:el1[0],titre:el1[1].titre})
        }
        var f2 = Object.entries(el1[1]['categorie'])
        f2.forEach((el2,key2) => {
         if(el2[1]['titre'].toLowerCase().includes(re)){
            this.selectedCategories.push({id:el2[0],titre:el2[1]['titre']})
          }
          if(el2[1]['categories'] !=null){
            var f3 = Object.entries(el2[1]['categories'])
            f3.forEach((el3,key3) => {
              var titreName = ""+el3[1];
              if(titreName != null &&titreName.toLowerCase().includes(re)){
                    this.selectedCategories.push({id:el3[0],titre:titreName})
               }
            })
          }

        })
      });
      console.log("################",this.selectedCategories);
      
  }
  getFournisseur(fournisseurs,req){
     fournisseurs.forEach(fournisseur => {
       if(fournisseur[1].toLowerCase().includes(req)){
             this.selectedFournisseurs.push({id:fournisseur[0],titre:fournisseur[1]})
       }
     });
  }
}
